import type { FieldRegistryItem } from '../../field-types'
import UserSelectEntitySidebar from './UserSelectEntitySidebar.vue'
import UserSelectField from './UserSelectField.vue'

export const userSelectField: FieldRegistryItem<'user_select'> = {
  field: UserSelectField,
  entitySidebar: UserSelectEntitySidebar,
}
